<template>
  <div class="df-config-recebido">
    <div>
      <App-Toggles :data-time="time" class="app-cpnt-field df-config-recebido--status"
        :cpntStatus='campos.status.status'
        :cpntId='campos.status.id'
        :cpntClassDivField='campos.status.classDivField'
        :cpntNome='campos.status.nome'
        :cpntValue='campos.status.value'
        :cpntDisabled='campos.status.disabled'
        :cpntMostrar='campos.status.mostrar'
        :cpntMensagem='campos.status.mensagem'
        :cpntMensagemTipo='campos.status.mensagemTipo'
        :cpntOn='campos.status.on'
        :cpntOff='campos.status.off'
        :cpntExplica='campos.status.explica'
        :cpntWidth='campos.status.width'
        :cpntTabIndex='campos.status.tabIndex'

        :cpntOnChange='campos.status.onChange'
        :cpntOnBlur='campos.status.onBlur'
        ref='status'
      ></App-Toggles>

      <App-Calendario :data-time="time" class="app-cpnt-field df-config-recebido--data" v-if="campos.status.value === true"
        :cpntStatus='campos.data.status'
        :cpntId='campos.data.id'
        :cpntClassDivField='campos.data.classDivField'
        :cpntNome='campos.data.nome'
        :cpntValue='campos.data.value'
        :cpntAutoComplete='campos.data.autocomplete'
        :cpntMask='campos.data.mask'
        :cpntOptionInicialNome='campos.data.optionInicialNome'
        :cpntOptionInicialValue='campos.data.optionInicialValue'
        :cpntDisabled='campos.data.disabled'
        :cpntMostrar='campos.data.mostrar'
        :cpntAutoFocus='campos.data.autofocus'
        :cpntMensagem='campos.data.mensagem'
        :cpntMensagemTipo='campos.data.mensagemTipo'
        :cpntPlaceholder='campos.data.placeholder'
        :cpntPosicionar='campos.data.posicionar'
        :cpntOnChange='campos.data.onChange'
        :cpntOnBlur='campos.data.onBlur'
        ref='data'
      ></App-Calendario>

      <App-Select :data-time="time" class="app-cpnt-field df-config-recebido--ciencia" v-if="campos.status.value === true"
        :cpntStatus='campos.ciencia.status'
        :cpntId='campos.ciencia.id'
        :cpntTabIndex='campos.ciencia.tabIndex'
        :cpntNome='campos.ciencia.nome'
        :cpntValue='campos.ciencia.value'
        :cpntMensagem='campos.ciencia.mensagem'
        :cpntMensagemTipo='campos.ciencia.mensagemTipo'
        :cpntDisabled='campos.ciencia.disabled'
        :cpntMostrar='campos.ciencia.mostrar'
        :cpntExplica='campos.ciencia.explica'
        :cpntPlaceholder='campos.ciencia.placeholder'
        :cpntValueRef='campos.ciencia.valueRef'
        :cpntRouter='campos.ciencia.router'
        :cpntMethod='campos.ciencia.method'
        :cpntField='campos.ciencia.field'
        :cpntWhere='campos.ciencia.where'
        :cpntAddButForm='campos.ciencia.addButForm'
        :cpntKeyMostra='campos.ciencia.keyMostra'
        :cpntTipoOrder='campos.ciencia.tipoOrder'
        :cpntOrder='campos.ciencia.order'
        :cpntOptions='campos.ciencia.options'
        :cpntKeyValue='campos.ciencia.keyValue'
        :cpntSearchMinimo='campos.ciencia.searchMinimo'
        :cpntMask='campos.ciencia.mask'
        :cpntOptionInicialNome='campos.ciencia.optionInicialNome'
        :cpntOptionInicialValue='campos.ciencia.optionInicialValue'

        :cpntOnBuscarOptions='campos.ciencia.onBuscarOptions'
        :cpntOnChange='campos.ciencia.onChange'
        :cpntOnBlur='campos.ciencia.onBlur'
        :cpntOnRealizaBusca='campos.ciencia.onRealizaBusca'
        :cpntOnKeyPressEnter='campos.ciencia.onKeyPressEnter'
        ref="ciencia"
      ></App-Select>
    </div>

    <div style="text-align: center; background-color: #d9e700; margin-bottom: 10px; padding: 5px 5px; border-radius: 6px; border-collapse: collapse; border-style: hidden; box-shadow: 0px 0px 0px 1px #c6c4c4;" v-if="campos.status.value === true">
      <div style="font-weight: bold; width: 100%; margin-bottom: 5px">Atenção!</div>
      <!-- <br/> -->
      A Sefaz só libera capturar as notas recebidas nos últimos 90 dias.
    </div>

    <div class="salvar"  v-if="campos.status.value === true">
      <RF-Button  :data-time="time" class="app-cpnt-field df-config-recebido--salvar"
        :cpntStatus='campos.salvar.status' 
        :cpntId='campos.salvar.id' 
        :cpntTipo='campos.salvar.tipo' 
        :cpntIcone='campos.salvar.icone' 
        :cpntTexto='campos.salvar.texto' 
        :cpntClass='campos.salvar.class'
        :cpntMostrar='campos.salvar.mostrar'
        :cpntExplica='campos.salvar.explica'
        :cpntTabIndex='campos.salvar.tabIndex'
        @onClickButton='campos.salvar.onClick'
      ></RF-Button>
    </div>
  </div>
</template>

<style scoped>
  .df-config-recebido {
    width: 550px;
  }
    .df-config-recebido > div {
      width: 100%;
      margin: 20px 0px;
    }
      .df-config-recebido > div > div {
        width: calc((100% / 3) - 10px);
      }
      .df-config-recebido > div > div:not(:last-child) {
        margin-right: 10px;
      }
    .df-config-recebido > div > .df-config-recebido--ciencia {
      margin-top: 25px;
    }
    
    .df-config-recebido > div.salvar {
      text-align: center;
    }
    .df-config-recebido > div.salvar > button {
      width: 100px;
    }
</style>

<script>
  export default {
    data: function () {
      return {
        time: '',
        statusGeral: '',
        campos: {
          status: {
            id: 'df-config-recebidos--status',
            status: '',
            nome: 'Buscar notas',
            value: false,
            onChange: this.dfConfigRecebidoOnChangeValue
          },
          ciencia: {
            id: 'df-config-recebidos--ciencia',
            status: '',
            nome: 'Auto ciência?',
            keyValue: 'id',
            keyMostra: [ 'nome' ], 
            options: [
              { id: 's', nome: 'Sim' },
              { id: 'n', nome: 'Não' }
            ],
            value: '',
            apiEnv: 'DFe_AutoCiencia',
            onChange: this.dfConfigRecebidoOnChangeValue
          },
          data: {
            id: 'df-config-recebidos--data',
            status: '',
            nome: 'Data de início',
            value: '',
            apiEnv: 'DFe_DatInicio',
            onChange: this.dfConfigRecebidoOnChangeValue
          },
          salvar: {
            status: '',
            tipo: 'texto',
            texto: 'Salvar',
            class: [ 'btn', 'btn-primary' ],
            mostrar: true,
            onClick: this.dfConfigRecebidoSalvar
          },
        }
      }
    },
    mounted: function () {
      this.dfConfigRecebidoIniciar()
    },
    methods: {
      dfConfigRecebidoIniciar: function () {
        this.dfConfigRecebidoBuscarConfiguracao((valores) => {
          // SETA O STATUS DA TELA
          this.dfConfigRecebidoSetarStatusGeral('carregando')
  
          // PEGA O NOME DE CADA CHAVE QUE DEVE SETAR O VALOR
          var chaves = Object.keys(this.campos)
  
          // RODA O VETOR DOS CAMPOS
          for (var indexC in chaves) {
            // SETA O NOME DA CHAVE QUE SERÁ TRABALHADA
            var chave = chaves[indexC]
  
            // SETA OS VALORES DO CAMPO
            this.dfConfigRecebidoSetarValorCampo(chave, valores)
  
            // SETA O VALOR INICIAL DO CAMPO
            this.campos[chave].valueIni = this.campos[chave].value
          }
  
          // SETA O STATUS DA TELA
          this.dfConfigRecebidoSetarStatusGeral('')
        })
      },
      dfConfigRecebidoBuscarConfiguracao: function (callback) {
        this.$store.state.comunicaAPI('/df/distribuicao/config/get', 'GET', null, (retorno) => {
          callback(retorno.data)
        }, this.dfConfigRecebidoSetarStatusGeral)
      },
      dfConfigRecebidoSetarValorCampo: function (chave, dados) {
        // INICIA A VARIAVEL DE VALOR
        var value = ''
        var valueRef = ''
        var options = null

        // VERIFICA O VALOR QUE DEVE SELECIONAR
        switch (chave) {
          case 'status':
            value = [ '', null, undefined ].indexOf(dados.DFe_DatInicio) === -1
            break

          case 'ciencia':
            value = [ '', null, undefined ].indexOf(dados.DFe_AutoCiencia) === -1 ? dados.DFe_AutoCiencia : 'n'
            break

          case 'data':
            value = [ '', null, undefined ].indexOf(dados.DFe_DatInicio) === -1 ? dados.DFe_DatInicio.split(' ')[0] : ''
            break
        }

        // PEGA OS OPTIONS DO CAMPO
        if (options === null && [ '', null, undefined ].indexOf(this.campos[chave].options) === -1 && this.campos[chave].options.length >= 1) {
          options = this.campos[chave].options
        }

        // VERIFICA SE TEM OPTION E O VALOR SELECIONADO É UM STRING
        if (options !== null && options.length >= 1 && typeof value === 'string') {
          // PEGA O VALOR DO CAMPO
          var valor = options.filter((option) => { return option[this.campos[chave].keyValue] === value })

          // SETA O VALOR ENCONTRADO
          value = valor.length === 1 ? valor[0] : value
        }

        // SETA O VALOR ATUALIZADO DO CAMPO
        this.$set(this.campos[chave], 'value', value)
        this.$set(this.campos[chave], 'valueRef', valueRef)

        // VERIFICA SE TEM VALOR PARA ATUALIZAR
        if (options !== null) {
          this.$set(this.campos[chave], 'options', options)
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      dfConfigRecebidoSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      dfConfigRecebidoOnChangeValue: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTÁ SENDO ALTERADO
        var indexF = id.split('--')

        // SETA O VALOR RECEBIDO
        this.$set(this.campos[indexF[1]], 'value', value)

        // LIMPA O CAMPO DE MENSAGEM DE ERRO
        this.$set(this.campos[indexF[1]], 'mensagem', '')

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA SE TEM QUE FAZER ALGUMA AÇÃO PARA O CAMPO
        switch (indexF[1]) {
          case 'status':
            if (value === false) {
              this.dfConfigRecebidoSalvar()
            } else {
              // IMPORTA BIBLIOTECA DEPENDENTE
              var moment = require('moment')

              // PEGA A DATA ATUAL
              var data = moment(this.$store.state.dadosApi.dataAtual, 'DD/MM/YYYY')

              // DIMINUI 91 DIAS
              data = data.subtract(91, 'd')

              // SETA O VALOR NO CAMPO
              this.$set(this.campos.data, 'value', data.format('DD/MM/YYYY'))
            }
            break
        }
      },
      dfConfigRecebidoSalvar: function () {
        // SETA OS VALORES RECEBIDOS
        this.$set(this.campos.salvar, 'status', 'carregando')

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // SETA A FUNÇÃO PARA FINALIZAÇÃO DO PROCESSO
        const finalizacao = () => {
          // SETA OS VALORES RECEBIDOS
          this.$set(this.campos.salvar, 'status', '')

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }

        // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
        const FUN_MONTAR_FORMDATA_API = require('@/assets/js/Funcoes-Gerais.js').FUN_MONTAR_FORMDATA_API

        // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
        FUN_MONTAR_FORMDATA_API(this.campos).then((formData) => {
          // VERIFICA SE O CAMPO TA ATIVADO
          if (this.campos.status.value === false) {
            formData = { DFe_DatInicio: '' }
          }

          // DFe_DatInicio
          // DFe_AutoCiencia

          // FAZ A COMUNICAÇÃO COM A API
          this.$store.state.comunicaAPI('/df/distribuicao/config', 'PUT', formData, (retorno) => {
            // APRESENTA A MENSAGEM DE SUCESSO
            this.$store.state.TRATAR_RET_LOT_API(retorno)
            
            // CHAMA A FUNÇÃO PARA FINALIZAR O PROCESSO
            finalizacao()
          }, this.dfConfigRecebidoSetarStatusGeral, (apiValid, apiStatus) => { this.dfConfigRecebidoTratarValidacao(apiValid, apiStatus, finalizacao) })
        })
      },
      dfConfigRecebidoTratarValidacao: function (apiValid, apiStatus = 400, callback = null) {
        // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
        const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API

        // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
        FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, this.campos, this).then(() => {
          if (callback !== null && typeof callback === 'function') {
            callback()
          }
        })
      }
    }
  }
</script>
